import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Access} from "@core/shared/models/access";
import {AllPaginateItemsAPI} from "@core/shared/models/all-paginate-items-api";

@Injectable({
    providedIn: 'root'
})
export class AccessService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient,
    ) {
    }

    public getItemsAPI(params?: string[]): Observable<Access[]> {

        return new AllPaginateItemsAPI<Access>(this.getPaginationItemsAPI.bind(this), params).request$;
    }

    public getManagedItemsAPI(): Observable<Access[]> {

        const params: string[] = [
            'isSystem[eq]=0'
        ];

        return new AllPaginateItemsAPI<Access>(this.getPaginationItemsAPI.bind(this), params).request$;
    }

    public getPaginationItemsAPI(params?: string[]): Observable<Access[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/accesses`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Access[]>(url, {
            headers: headers
        });
    }
}
